import axios from "axios";

// Sandbox by default (https://devapi.slick-pay.com/api/v2/). Switch
// VUE_APP_SLICKPAY_BASEURL to https://prodapi.slick-pay.com/api/v2/ and use a
// live public key once the integration has been validated in sandbox.
//
// IMPORTANT: this Bearer key is bundled into the frontend JS and is therefore
// visible to anyone opening devtools. That's acceptable for the sandbox key
// used here, but a production key should not be called directly from the
// browser this way — proxy invoice creation/verification through a backend
// endpoint instead so the key never leaves the server.
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_SLICKPAY_BASEURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.VUE_APP_SLICKPAY_PUBLIC_KEY}`,
  },
});

export default {
  // POST users/contacts
  async createContact(data) {
    const { data: body } = await apiClient.post("users/contacts", data);
    return body;
  },
  // GET users/contacts/{uuid}
  async getContact(uuid) {
    const { data: body } = await apiClient.get(`users/contacts/${uuid}`);
    return body;
  },
  // POST users/invoices
  async createInvoice(data) {
    const { data: body } = await apiClient.post("users/invoices", data);
    return body;
  },
  // GET users/invoices/{id}
  async getInvoice(id) {
    const { data: body } = await apiClient.get(`users/invoices/${id}`);
    return body;
  },
  // GET users/invoices?fake=1&offset=&page=
  async listInvoices(offset = 0, page = 1) {
    const { data: body } = await apiClient.get("users/invoices", {
      params: { fake: 1, offset, page },
    });
    return body;
  },
};
